import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {PresignRequest, PresignResponse} from './upload.models';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class UploadService {
  // Endpoint API Gateway
  private readonly presignEndpoint = `${environment.auth.apiBaseUrl}/backend/spa/presign_url`;

  constructor(private http: HttpClient) {
  }

  getPresignedUrl(req: PresignRequest): Observable<PresignResponse> {
    return this.http.post<PresignResponse>(this.presignEndpoint, req);
  }

  uploadToS3(presign: PresignResponse, file: File): Observable<number> {
    const headers = new HttpHeaders({
      ...(presign.headers ?? {}),
      // verify that the content-type is what was signed
      'Content-Type': file.type || 'application/octet-stream',
    });

    const request = new HttpRequest('PUT', presign.uploadUrl, file, {
      headers,
      reportProgress: true,
      responseType: 'text',
    });

    const start = performance.now();
    let lastLoaded = 0;
    let lastTime = start;

    return this.http.request(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          const loaded = event.loaded ?? 0;
          const total = event.total ?? file.size;
          const progress = total ? Math.round((loaded / total) * 100) : 0;

          // (optionnel) calculate upload speed
          const now = performance.now();
          const dt = (now - lastTime) / 1000;
          if (dt > 0.2) {
            const dLoaded = loaded - lastLoaded;
            const speed = dLoaded / dt; // bytes/sec
            // we could expose speed via another observable if needed
            lastLoaded = loaded;
            lastTime = now;
          }

          return progress;
        }

        if (event.type === HttpEventType.Response) {
          return 100;
        }

        return 0;
      })
    );
  }
}
